export default {
  "content": "<path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M1 4.73L3.76 7.4 9 1\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "10",
    "height": "9",
    "fill": "none",
    "viewBox": "0 0 10 9"
  }
};